import { ClientPlaceholder } from './ClientPlaceholder';

/** `/invite/:token` — onboarding for clients the professional already has. */
export function Invite() {
  return (
    <ClientPlaceholder
      icon="user"
      titleKey="client.invite.title"
      descriptionKey="client.invite.description"
    />
  );
}
